module.exports = __webpack_public_path__ + "img/submit-bt.3b2d611e.png";